var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.155 4.138h-.776v-1.81A2.33 2.33 0 009.052 0a2.33 2.33 0 00-2.328 2.328v.635c0 .804-.54 1.52-1.313 1.74l-.756.217v-.006a.776.776 0 00-.776-.776H.776A.776.776 0 000 4.914v8.276c0 .428.347.776.776.776h3.103c.399 0 .727-.301.77-.688a4.37 4.37 0 002.35.688h5.156A2.848 2.848 0 0015 11.12V6.983a2.848 2.848 0 00-2.845-2.845zm-9.052 8.276H1.552V5.69h1.551v6.724zm10.345-1.293c0 .713-.58 1.293-1.293 1.293H7a2.824 2.824 0 01-2.344-1.254V6.534l1.182-.338a3.376 3.376 0 002.439-3.233v-.635a.777.777 0 011.552 0v2.586c0 .428.347.776.775.776h1.552c.713 0 1.293.58 1.293 1.293v4.138z",
    fill: "#55974B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "5eb9a03e57d625d7bab4ff4bec13a7ff.svg";
export { MemoForwardRef as ReactComponent };